import { render, staticRenderFns } from "./BotaoUsuarios.vue?vue&type=template&id=9a9afe58&lang=pug"
import script from "./BotaoUsuarios.vue?vue&type=script&lang=js"
export * from "./BotaoUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports